import React from 'react';
import { i18n } from 'config/locales';
import Textarea from '../Textarea';
import ValidationElement from '../ValidationElement';
import LinkButton from '../LinkButton';
import SvgComponent from '../SvgComponent';
import Field from '../Field';

export default class Comments extends ValidationElement {
  constructor(props) {
    super(props);

    this.state = {
      visible: this.props.visible,
    };

    this.toggle = this.toggle.bind(this);
    this.visible = this.visible.bind(this);
    this.update = this.update.bind(this);
    this.updateComments = this.updateComments.bind(this);
  }

  update(queue) {
    this.props.onUpdate({
      name: this.props.name,
      value: this.props.value,
      ...queue,
    });
  }

  updateComments(values) {
    this.update({
      value: values.value,
    });
  }

  toggle() {
    const future = !this.visible();
    const value = future ? this.props.value : '';
    this.setState({ visible: future }, () => {
      this.update({ value });
    });
  }

  visible() {
    return this.props.value || this.state.visible;
  }

  getTitle() {
    if (!this.props.title) {
      return '';
    }

    return <span className="title">{this.props.title}</span>;
  }

  render() {
    const { minimalMarginBottom, negativeMarginTop } = this.props;
    const klass = `comments ${this.props.className || ''}`.trim();

    return (
      <Field
        title={this.getTitle()}
        name="Comments"
        className={`${minimalMarginBottom ? 'minimal-margin-bottom ' : ''}${negativeMarginTop ? 'negative-margin-top ' : ''}optional-comments-form`}
      >
        {!this.visible() && (
          <div className="comment-section" style={{}}>
            {this.props.children}
            <div className={klass}>
              <LinkButton
                classContent="add-comment"
                className="link-button"
                onClick={() => this.toggle()}
              >
                <span>{i18n.t(this.props.addLabel)}</span>
                <div className="plus-circle" aria-hidden="true">
                  <SvgComponent className="plus-circle" src="/img/plus-circle.svg" />
                </div>
              </LinkButton>
            </div>
          </div>
        )}
        {this.visible() && (
          <div className="comments-section active">
            {this.props.children}
            <Textarea
              name="comments"
              {...this.props}
              attribute={this.props.attribute}
              onUpdate={this.props.onUpdate || this.updateComments} // eslint-disable-line @typescript-eslint/unbound-method
              onError={this.props.onError}
            />
            <div className={klass}>
              <LinkButton
                classContent="remove-comment"
                className="link-button"
                onClick={() => this.toggle()}
              >
                <span>{i18n.t(this.props.removeLabel)}</span>
                <div className="cross-circle" aria-hidden="true">
                  <SvgComponent className="cross-circle" src="/img/cross-circle.svg" />
                </div>
              </LinkButton>
            </div>
          </div>
        )}
      </Field>
    );
  }
}

Comments.defaultProps = {
  value: '',
  visible: false,
  title: '',
  onUpdate: () => { },
  addLabel: 'comments.add',
  removeLabel: 'comments.remove',
  onError: (value, arr) => arr,
  minimalMarginBottom: true,
  negativeMarginTop: true,
};

Comments.errors = [];
